import { render, staticRenderFns } from "./CounselorMain.vue?vue&type=template&id=18ee1758&scoped=true"
import script from "./CounselorMain.vue?vue&type=script&lang=js"
export * from "./CounselorMain.vue?vue&type=script&lang=js"
import style0 from "./CounselorMain.vue?vue&type=style&index=0&id=18ee1758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee1758",
  null
  
)

export default component.exports